import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, OnChanges, ViewChild, HostListener } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { DateFieldService } from '../../../../core/generic/_services/date-field.service';
import { Subscription } from 'rxjs';
import { DATE_FIELD_OPTIONS, DateFieldOption } from '../../../../core/common/constants/date-field.constants';

@Component({
  selector: 'kt-date-field-selector',
  templateUrl: './date-field-selector.component.html',
  styleUrls: ['./date-field-selector.component.scss']
})
export class DateFieldSelectorComponent implements OnInit, OnDestroy, OnChanges {

  @ViewChild('selectElement') selectElement: MatSelect;

  @Input() selectedField: string | null = null;
  @Input() defaultDateField: string = DATE_FIELD_OPTIONS[0]?.id;
  @Output() dateFieldChange = new EventEmitter<string>();

  selectedFieldName = (DATE_FIELD_OPTIONS[0]?.name);
  dateFieldOptions: DateFieldOption[] = DATE_FIELD_OPTIONS;
  private readonly _subscriptions = new Subscription();
  constructor(private readonly dateFieldService: DateFieldService) { }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.selectElement || !this.selectElement.panelOpen){
      return;
    }

    const target = event.target as HTMLElement;

    const clickedInsideSelector =
      !!target.closest('.date-field-dropdown') ||
      !!target.closest('.cdk-overlay-pane') ||
      !!target.closest('.date-field-panel');

    const clickedInsideDateRange =
      !!target.closest('.date-range-container') || !!target.closest('.date-range-menu');

    if (clickedInsideDateRange && !clickedInsideSelector) {
      this.selectElement.close();
      return;
    }

    if (!clickedInsideSelector && !clickedInsideDateRange) {
      this.selectElement.close();
    }
  }


  ngOnInit(): void {
    const storedDateField = this.dateFieldService.getSelectedDateField();
    this.selectedField = this.selectedField || storedDateField || this.defaultDateField;
    this.dateFieldService.setSelectedDateField(this.selectedField);
    this.updateSelectedFieldName(this.selectedField);

    this._subscriptions.add(
      this.dateFieldService.dateFieldSelectionChanged.subscribe((fieldId: string) => {
        this.selectedField = fieldId;
        this.updateSelectedFieldName(fieldId);
      })
    );
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.defaultDateField && !changes.defaultDateField.firstChange) {
      const storedDateField = this.dateFieldService.getSelectedDateField();
      this.selectedField = storedDateField || this.selectedField || this.defaultDateField;
      this.dateFieldService.setSelectedDateField(this.selectedField);
      this.updateSelectedFieldName(this.selectedField);
    }

    if (changes.selectedField && !changes.selectedField.firstChange) {
      this.dateFieldService.setSelectedDateField(changes.selectedField.currentValue);
      this.updateSelectedFieldName(changes.selectedField.currentValue);
    }
  }

  onFieldChange(fieldId: string): void {
    this.selectedField = fieldId;
    this.updateSelectedFieldName(fieldId);
    this.dateFieldService.setSelectedDateField(fieldId);
    this.dateFieldChange.emit(fieldId);
  }

  private updateSelectedFieldName(fieldId: string | null): void {
    const field = DATE_FIELD_OPTIONS.find(f => f.id === fieldId);
    this.selectedFieldName = field ? field.name : (DATE_FIELD_OPTIONS[0]?.name);
  }
}